import React from "react";
import { Text } from "../../Text";
export const DefaultHeaderCell = ({ children, column, testId }) => {
    const { align } = column.columnDef;
    const canBeSorted = column.getCanSort() !== false;
    const columnAlignment = align !== null && align !== void 0 ? align : "left";
    const justifyContent = canBeSorted ? "left" : columnAlignment;
    return (React.createElement(Text, { flex: 1, "data-testid": testId, display: "flex", flexDirection: "row", justifyContent: justifyContent }, children));
};
